import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<label class=\"body-1 form-elements-label\" ...attributes>\n  {{@label}}\n  {{#if @isOptional}}\n    {{t \"ui-kit.form-elements.optional\"}}\n  {{/if}}\n</label>", {
  moduleName: "@qonto/ui-kit/components/form-elements/label.hbs"
});